const Created = "created";
const Requested = "requested";
const Paid = "paid";

function all(): string[] {
  return [Created, Requested, Paid];
}

export default {
  Created,
  Requested,
  Paid,
  all
};
